module.exports = __webpack_public_path__ + "img/uzis_logo.3174278a.png";